import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VersionDialogComponent } from '../version-dialog/version-dialog.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-version-link',
  templateUrl: './version-link.component.html',
  styleUrls: ['./version-link.component.scss']
})
export class VersionLinkComponent implements OnInit {
  amb:string = ''
  @Input() customClass: string = '';

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.amb = environment.amb
  }

  openVersion() {
    const options = {
      width: '500px',
      disabledClose: false
    }
    this.dialog.open(VersionDialogComponent, options)
  }

}
